import React, {useEffect, useRef, useState} from "react";
import {toast} from "react-toastify";
import {modifyGroupPost} from "../../../../services/UserService";
import Utils from "../../../../utils";

function ModifyGroup(props) {

    const [groupId, setGroupId] = useState(0);
    const [groupUserList, setGroupUserList] = useState([]);
    const [searchUser, setSearchUser] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [groupName, setGroupName] = useState('');

    const clsModifyGroup = useRef(null);

    useEffect(function () {
        setGroupId(parseInt(props.groupData.id));
        setGroupName(props.groupData.name ? props.groupData.name : '');
        setGroupUserList(props.userList.length > 0 ? props.userList : []);

        let userList = [];
        for (let i = 0; i < props.userList.length; i++) {
            let index = props.groupData.users.findIndex(x => parseInt(x) === parseInt(props.userList[i]['id']));
            if (index > -1) {
                userList.push(props.userList[i]);
            }
            setSelectedUsers(userList);
        }

    }, [props?.groupData, props.userList]);

    const handleSearchUser = (e) => {
        let value = e.target.value;
        setSearchUser(value);

        if (value.trim()) {
            let users = [...props.userList];
            let newUserList = [];
            for (let i = 0; i < users.length; i++) {
                let userName = users[i]['first_name'] + ' ' + users[i]['last_name'];
                if (userName.search(value) > -1 || users[i]['email'].search(value) > -1) {
                    newUserList.push(users[i]);
                }
            }
            setGroupUserList(newUserList);
        } else {
            setGroupUserList(props.userList);
        }
    };

    const handleSelectUser = (e, data) => {
        e.preventDefault();

        let selectUsers = [...selectedUsers];
        let index = selectUsers.findIndex(x => parseInt(x.id) === parseInt(data.id));
        if (index === -1) {
            selectUsers.push(data);
            setSelectedUsers(selectUsers);
        } else {
            toast.error('User Already added');
        }
    };

    const handleRemoveSelectUser = (e, data) => {
        e.preventDefault();

        let selectUsers = [...selectedUsers];
        let index = selectUsers.findIndex(x => parseInt(x.id) === parseInt(data.id));
        selectUsers.splice(index, 1);
        setSelectedUsers(selectUsers);
    };

    const handleClearModifyUser = (e) => {
        e.preventDefault();

        props.setGroupData({
            id: 0,
            name: '',
            users: []
        });
        setGroupUserList([]);
        setSearchUser('');
    };

    const handleSubmitGroup = (e) => {
        e.preventDefault();
        let error = false;

        if (!groupName) {
            toast.error('Group name is required');
            error = true;
        } else if (selectedUsers.length === 0) {
            toast.error('Please select user');
            error = true;
        }

        if (error) return;

        props.setLoading(true);

        let users = [];
        for (let i = 0; i < selectedUsers.length; i++) {
            users.push(selectedUsers[i]['id']);
        }

        let obj = {
            id: groupId,
            name: groupName,
            users: users
        };

        modifyGroupPost(obj)
            .then(response => {
                props.setLoading(false);
                clsModifyGroup?.current.click();
                toast.success(response.data.message);
                props.setIsCall(!props.isCall);
            })
            .catch(err => {
                props.setLoading(false);
                toast.error(Utils.getErrorMessage(err));
            });
    };

    return (
        <div className="offcanvas offcanvas-end AddDocument AddTemplate templates_page" id="modifyGroup">
  {/* HEADER */}
  <div className="setting-offcanvas-header">
    <h5 className="setting-offcanvas-title">
      {groupId > 0 ? "Update Group" : "Create Group"}
    </h5>

    <button
      type="button"
      className="setting-close-btn"
      data-bs-dismiss="offcanvas"
      onClick={handleClearModifyUser}
      ref={clsModifyGroup}
    >
      <i className="bi bi-x-lg"></i>
    </button>
  </div>

  {/* BODY */}
  <div className="setting-offcanvas-body">

    <div className="setting-group-grid">
      {/* LEFT SIDE — USER LIST */}
      <div className="setting-group-left">

        <div className="setting-section-header">
          <h2>Add Users to the Group</h2>
          <input
            value={searchUser}
            onChange={handleSearchUser}
            className="setting-input"
            placeholder="Search user"
          />
        </div>

        <div className="setting-table-wrapper">
          <table className="setting-table">
            <thead>
              <tr>
                <th>User Details</th>
                <th>Role</th>
                <th className="setting-col-small">Add</th>
              </tr>
            </thead>

            <tbody>
              {groupUserList.map((item, index) => (
                <tr key={index}>
                  <td>
                    <div className="setting-user-card">
                      <span className="setting-user-name">
                        {item.first_name} {item.last_name}
                      </span>
                      <span className="setting-user-email">{item.email}</span>
                    </div>
                  </td>

                  <td>{item.role_name}</td>

                  <td>
                    <i
                      onClick={(e) => handleSelectUser(e, item)}
                      className="bi bi-plus-lg setting-icon-add"
                    ></i>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>

      {/* RIGHT SIDE — SELECTED USERS */}
      <div className="setting-group-right">

        <div className="setting-section-header">
          <h2>Group Name</h2>
          <input
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            className="setting-input"
            placeholder="Enter group name"
          />
        </div>

        <div className="setting-selected-list">
          <h2 className="setting-selected-title">Added Users</h2>

          {selectedUsers.map((item, index) => (
            <div key={index} className="setting-selected-item">
              <div className="setting-user-card">
                <span className="setting-user-name">
                  {item.first_name} {item.last_name}
                </span>
                <span className="setting-user-email">{item.email}</span>
              </div>

              <button
                className="setting-remove-btn"
                onClick={(e) => handleRemoveSelectUser(e, item)}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>
          ))}
        </div>

      </div>
    </div>

    {/* FOOTER */}
    <div className="setting-footer">
      <button
        type="button"
        className="setting-btn-cancel"
        data-bs-dismiss="offcanvas"
        onClick={handleClearModifyUser}
      >
        Cancel
      </button>

      <button
        type="button"
        className="setting-btn-primary"
        onClick={handleSubmitGroup}
      >
        Save
      </button>
    </div>
  </div>
</div>

    );
}

export default ModifyGroup;